import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  QueryList,
  ViewChildren
} from '@angular/core';
import {FavoritesService} from "../../favorites/favorites.service";
import {OverlayService} from "../../overlay/overlay.service";
import {Router} from "@angular/router";
import {Overlayable} from "../../interfaces/overlayable";
import {NotificationService} from "../../atoms/notification/notification.service";
import {CdColor} from "../../enums/cd-color";

@Component({
  selector: 'brt-code-input',
  templateUrl: './code-input.component.html',
  styleUrls: ['./code-input.component.scss']
})
export class CodeInputComponent implements AfterViewInit, Overlayable {
  @ViewChildren('inputEl') inputEls: QueryList<ElementRef<HTMLInputElement>> = new QueryList<ElementRef<HTMLInputElement>>();
  @Output("onClosed") onClosed = new EventEmitter<boolean>();
  codeLength = 4;
  code: string[] = new Array(this.codeLength).fill("");
  isConfirmEnabled = false;
  disabledInputs: boolean[] = new Array(this.codeLength).fill(false);
  submitButtonLabel = "Los";

  isLoading = false;
  @Input('title') title: string = "";
  @Input('submitButtonLabel') set setSubmitButtonLabel(val: string) {
    if(val && val.length) {
      this.submitButtonLabel = val;
    }
  };
  @Input('submitCallback') submitCallback: ((code: string) => void) = (code: string) => {
    this.onClosed.emit(true);
  }

  @Input('submitCallbackAsync') submitCallbackAsync?: ((code: string) => Promise<void>);

  @Input('pattern') set setPattern(pattern: string) {
    this.pattern = pattern;
    this.resetCode();
  }

  pattern: string = "****";

  cmdPressed = false;

  @HostListener("keydown", ['$event']) onCmdPressed($event: KeyboardEvent) {
    if ($event.key == "Meta" || $event.key == "Control") this.cmdPressed = true;
  }

  @HostListener("keyup", ['$event']) onCmdReleased($event: KeyboardEvent) {
    if ($event.key == "Meta" || $event.key == "Control") this.cmdPressed = false;
  }


  constructor(private favorites: FavoritesService, private overlay: OverlayService, private router: Router, private notificationService: NotificationService) {
  }

  ngAfterViewInit() {
    this.focusNextAvailableInput(-1);

    this.resetCode();


  }

  resetCode() {

    const patternArr = this.pattern.split("");
    this.codeLength = patternArr.length;
    for(let i = 0; i < this.codeLength; i++) {
      const requiredSymbol = patternArr[i];
      const isRequiredSymbol = requiredSymbol !== "*";
      if(isRequiredSymbol) {
        this.code[i] = requiredSymbol;
      } else {
        this.code[i] = "";
      }
      this.disabledInputs[i] = isRequiredSymbol;
    }


    this.code.forEach((el, idx) => {
      const inputEl = this.inputEls.get(idx)?.nativeElement;
      if(inputEl) {
        inputEl.value = el;
      }
    })
  }

  submit() {
    if(this.isConfirmEnabled) {
      this.isConfirmEnabled = false;
      const codeStr = this.code.join("");
      if(codeStr.length === this.codeLength) {
        // console.log("Submitting ", this.code.join(""));
        this.isLoading = true;
        const oldButtonLabel = this.submitButtonLabel;
        this.submitButtonLabel = "Wird geladen...";
        this.onClosed.emit();
        this.submitCallback(codeStr);

        if(this.submitCallbackAsync) {
          this.submitCallbackAsync(codeStr).then(() => {
            this.isLoading = false;
            this.resetCode();
            this.submitButtonLabel = oldButtonLabel;
          })
        }
      }
    }

  }

  afterInputChange($event: KeyboardEvent, idx: number) {
    const htmlEl = $event.target as HTMLInputElement;
    $event.preventDefault();

  }

  beforeInputChange($event: KeyboardEvent, idx: number) {
    const htmlEl = $event.target as HTMLInputElement;
    const oldValue = htmlEl.value;

    if(this.cmdPressed) {
      return;
    } else if($event.key === "Tab") {
      return;

    } else if($event.key === "Enter") {
      $event.preventDefault();
      this.submit();
      return;
    } else if($event.key === "Backspace" || $event.key === "Delete") {
      this.code[idx] = "";
      this.isConfirmEnabled = false;

      if(oldValue.length === 0 && idx > 0) {
        this.focusPreviousAvailableInput(idx);
      }
      return;

    } else if(!this.validateSymbol($event.key)) {
      $event.preventDefault();
      return;
    }

    if(oldValue.length === 1) {
      this.focusNextAvailableInput(idx);
      // $event.preventDefault();
      // return;
    }

    this.code[idx] = $event.key.toUpperCase();
    htmlEl.value = this.code[idx];

    this.isConfirmEnabled = this.code.join("").length === this.codeLength;


    this.focusNextAvailableInput(idx);
    // if(idx < (this.codeLength - 1)) {
    //   const nextInputEl = this.inputEls.get(idx + 1)?.nativeElement as HTMLInputElement;
    //   window.requestAnimationFrame(() => {
    //     nextInputEl.focus();
    //   });
    // }

    $event.preventDefault();

  }

  focusNextAvailableInput(currentIdx: number): void {
    let localIdx = currentIdx + 1;
    const maxIdx = this.codeLength - 1;
    while(localIdx <= maxIdx) {
      const nextEl = this.inputEls.get(localIdx);

      if(nextEl) {
        const nextInputEl = nextEl.nativeElement as HTMLInputElement;

        if(!nextInputEl.disabled) {
          window.requestAnimationFrame(() => {
            // console.log("Set focus");
            nextInputEl.focus();
          });
          break;
        }
      }

      localIdx++;
    }
  }

  focusPreviousAvailableInput(currentIdx: number): void {
    let localIdx = currentIdx - 1;
    const minIdx = 0;
    while(localIdx >= minIdx) {
      const prevEl = this.inputEls.get(localIdx);

      if(prevEl) {
        const nextInputEl = prevEl.nativeElement as HTMLInputElement;

        if(!nextInputEl.disabled) {
          window.requestAnimationFrame(() => {
            // console.log("Set focus");
            nextInputEl.focus();
          });
          break;
        }
      }

      localIdx--;
    }
  }

  onCodeChange() {
    // console.log(this.code);
  }

  validateSymbol(symbol: string): boolean {
    if(symbol.length !== 1) return false;
    return symbol.match(/[a-z0-9]/i) !== null;
  }

  onPaste(event: ClipboardEvent, idx: number) {

    event.preventDefault();

    // @ts-ignore
    let clipboardData = event.clipboardData || window.clipboardData;
    let pastedText = clipboardData.getData('text');

    const pastedTextArr = pastedText.split("").slice(0, this.codeLength);

    const isPastedTextSameLengthAsRequired = pastedTextArr.length === this.codeLength;
    let skipIndex = 0;
    if(!isPastedTextSameLengthAsRequired) {
      for(let i = 0; i < this.disabledInputs.length; i++) {
        if(this.disabledInputs[i]) {
          skipIndex++;
        } else {
          break;
        }
      }
    }
    let currentInputIndex = isPastedTextSameLengthAsRequired ? 0 : Math.min(this.codeLength - pastedTextArr.length, skipIndex);
    pastedTextArr.forEach((symbol: any, idx: number) => {
      if(!this.disabledInputs[currentInputIndex]) {
        this.code[currentInputIndex] = symbol;

        if(typeof this.inputEls.get(currentInputIndex) !== "undefined") {
          // @ts-ignore
          this.inputEls.get(currentInputIndex).nativeElement.value = symbol;
        }


      }

      currentInputIndex++;
    })
    this.isConfirmEnabled = this.code.join("").length === this.codeLength;

  }
}
